package pwgs.ui.scenes.projectinvitations

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.utils.EHAlign

class MProjectInvitationsScene(props: ProjectInvitationsSceneProps) : AScene<ProjectInvitationsSceneProps, ProjectInvitationsSceneModel, ProjectInvitationsSceneState, ProjectInvitationsControllerFe>(props) {

    override fun createController() : ProjectInvitationsControllerFe {
        return ProjectInvitationsControllerFe(props, this)
    }

    override fun initState() : ProjectInvitationsSceneState {
        return ProjectInvitationsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        var m = this@MProjectInvitationsScene.model
        Card {
            isLoading = m.isLoading
            header("Pending invitations") {
                ResponsiveButtonWithIcon("add", "Invite member", EButtonColor.Primary, this@MProjectInvitationsScene.controller::onInviteMemberButtonClicked)
            }

            body {
                Table {
                    columns {
                        fixedColumn("Email")
                        fixedColumn("Permission")
                        fixedColumn("", hAlign = EHAlign.Right)
                    }

                    body {
                        m.invitations.forEach { inv ->
                            row {
                                cell(inv.email)
                                cell(inv.userLevel.name)
                                cell {
                                    IconButton("restart_alt") {
                                        variant = EButtonVariant.Link
                                        size = EButtonSize.Small
                                        color = EButtonColor.Primary
                                        onClick = {this@MProjectInvitationsScene.controller.resendInvitation(inv.id)}
                                    }
                                    IconButton("delete") {
                                        variant = EButtonVariant.Link
                                        size = EButtonSize.Small
                                        color = EButtonColor.Danger
                                        onClick = {this@MProjectInvitationsScene.controller.revokeInvitation(inv.id)}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (m.inviteDialogModel != null) {
            val dlg = m.inviteDialogModel!!
            Modal("Invite member") {
                isLoading = dlg.isLoading
                error = dlg.error
                infoText = "Fill the form below to invite an user to join this project"

                TextField("Email", dlg.emailField)

                footer {
                    Button("Cancel", EButtonColor.Secondary, EButtonVariant.Link, this@MProjectInvitationsScene.controller::onCancelInviteButtonClicked)
                    Button("Invite", EButtonColor.Primary, EButtonVariant.Filled, this@MProjectInvitationsScene.controller::onSendInvitationButtonClicked)
                }
            }
        }
    }
}

class ProjectInvitationsSceneState {

}

fun Components.ProjectInvitationsScene(props: ProjectInvitationsSceneProps) = this.registerComponent(MProjectInvitationsScene(props), {})
